import { render, staticRenderFns } from "./ViewAllMyCourses.html?vue&type=template&id=413f79f4&scoped=true&"
import script from "./ViewAllMyCourses.vue?vue&type=script&lang=js&"
export * from "./ViewAllMyCourses.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllMyCourses.scss?vue&type=style&index=0&id=413f79f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f79f4",
  null
  
)

export default component.exports